import React from "react";
import { CLOSING_CTA, CTA_MICRO_DISCLOSURE } from "../shared/ctaContent.js";

const QuietClosingCta = ({ onOpenModal }) => (
  <section
    className="cursor-section cursor-closing-cta-section"
    data-testid="quiet-closing-cta"
  >
    <div className="cursor-closing-cta-inner">
      <h2 className="cursor-closing-cta-headline">
        {CLOSING_CTA.headline.lead}{" "}
        <span className="cursor-closing-cta-headline-accent">
          {CLOSING_CTA.headline.accentPrimary}
        </span>{" "}
        {CLOSING_CTA.headline.leadMid}{" "}
        <span className="cursor-closing-cta-headline-accent">
          {CLOSING_CTA.headline.accentSecondary}
        </span>
      </h2>
      <p className="cursor-closing-cta-subhead">{CLOSING_CTA.subheadline}</p>
      <div className="cursor-closing-cta-shell">
        <button
          type="button"
          className="quiet-cta quiet-cta-primary"
          onClick={onOpenModal}
          data-testid="quiet-closing-cta-button"
        >
          <span>{CLOSING_CTA.buttonLabel}</span>
          <span className="quiet-cta-arrow" aria-hidden="true">
            →
          </span>
        </button>
        <div className="cursor-cta-caption-block" data-testid="quiet-closing-cta-disclosure">
          <p className="cursor-cta-caption">{CTA_MICRO_DISCLOSURE.line1}</p>
          <p className="cursor-cta-caption cursor-cta-caption-secondary">
            {CTA_MICRO_DISCLOSURE.line2}
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default QuietClosingCta;
